import { useTranslation } from 'react-i18next'

import { InputWithLabel } from '@reveni-io/reveni-ui'

import { errorTypes } from '../constants'
import SectionHeader from '../SectionHeader/SectionHeader'
import CustomName from './CustomName/CustomName'
import { handleChangeCustomName } from './helpers'
import * as Styles from './styles'

const GeneralSection = ({ internalName, names, languages, errors, onChangeInternalName, onChange }) => {
  const { t } = useTranslation()

  const internalNameError = errors?.find(error => error.type === errorTypes.internalNameEmpty)
  const showCustomNamesError = !!errors?.find(error => error.type === errorTypes.customNamesEmpty)

  const handleChangeNames = newNames => handleChangeCustomName(newNames, onChange)

  return (
    <Styles.Container>
      <SectionHeader
        title={t('General')}
        description={t(
          'Nombra este método de devolución para que tu equipo pueda identificarlo y los clientes sepan qué esperar'
        )}
      />
      <div id={errorTypes.internalNameEmpty}>
        <InputWithLabel
          label={t('Nombre interno')}
          value={internalName}
          onChange={onChangeInternalName}
          error={internalNameError}
          helperText={t('Solo visible para tu equipo. No se muestra al cliente.')}
          fullWidth
        />
      </div>
      <CustomName names={names} languages={languages} onChange={handleChangeNames} showError={showCustomNamesError} />
    </Styles.Container>
  )
}

export default GeneralSection
